import { CRM } from "@/components/atomic-crm/root/CRM";
import { rcAvenueConfiguration } from "./rcAvenueConfiguration";

const App = () => <CRM {...rcAvenueConfiguration} />;

export default App;
